export default {
  editTitle: 'Editar Modelo Personalizado',
  newTitle: 'Novo Modelo Personalizado',
  create: 'Criar',
  save: 'Salvar',
  warning: 'Aviso',
  saveWarningMessage: 'Salvar as alterações excluirá todas as simulações deste modelo, e excluirá e reprocessará o Relatório do Modelo.',
  cannotBeUndone: 'Esta ação não pode ser desfeita. Tem certeza?',
  abort: 'Cancelar',
  confirm: 'Confirmar',
  creatingCustomModel: 'Criando Modelo Personalizado...',
  search: 'Buscar',
  select: 'Selecionar',
  close: 'Fechar',
  modelName: 'Nome do Modelo',
  country: 'País',
  countryTooltip: 'País para o qual o Modelo Personalizado será criado',
  referenceType: 'Tipo de referência',
  ekrmReference: 'Modelo de Referência de Conhecimento Especializado',
  standardReference: 'Modelo de Referência Padrão',
  category: 'Categoria',
  categoryTooltip: 'Categoria de referência que será utilizada para criar o Modelo Personalizado',
  referenceBrands: 'Marcas de Referência',
  referenceBrandsTooltip: 'Marca de referência dentro da categoria selecionada sobre a qual o Modelo Personalizado será criado',
  modelStartDate: 'Data de início do Modelo',
  modelStartDateTooltip: 'Data inicial para o Modelo Personalizado. Este será o ponto de partida para o relatório do modelo, e determinará quão longe no futuro diferentes simulações/otimizações podem ser realizadas.',
  sales: 'Vendas',
  averageMonthlySales: 'Vendas Mensais Médias',
  averageMonthlySalesTooltip: 'Receita mensal média (em USD) da marca alvo para a qual este Modelo Personalizado será criado. Definir corretamente este valor garantirá uma melhor correspondência entre o Modelo de Referência e o Modelo Personalizado que está sendo criado.',
  usdPerUnit: 'USD por Unidade',
  usdPerUnitTooltip: 'Quando o Modelo de Referência correspondente é modelado com um valor de KPI em unidades vendidas (em vez de receita), este parâmetro de conversão é necessário para transformar essas unidades vendidas em receita para a marca alvo.',
  spendAndAttribution: 'Gasto e Atribuição',
  spendAndAttributionTooltip: 'Estes são os diferentes gastos mensais médios e a contribuição média para vendas do Gasto Controlável Próprio (a porção do gasto em mídia que é completamente controlável pela marca), Gasto de Co-Marketing (a porção de mídia que não é direcionada especificamente à marca/produto, mas que afeta indiretamente seus resultados) e Gasto em Mídia da Concorrência (quanto, como total mensal agregado, os concorrentes diretos/relevantes estão gastando na categoria)',
  avgMonthlyOwnSpend: 'Gasto Mensal Médio Controlável Próprio',
  salesAttributedToOwnMedia: 'Vendas Atribuídas à Mídia Controlável Própria',
  avgMonthlyComarketingSpend: 'Gasto Mensal Médio de Co-Marketing',
  salesAttributedToComarketing: 'Vendas Atribuídas ao Co-Marketing',
  avgMonthlyCompetitionSpend: 'Gasto Mensal Médio da Concorrência',
  avgMonthlyCompetitionSales: 'Vendas Mensais Médias da Concorrência',
  salesAttributedToCompetitionMedia: 'Vendas Atribuídas à Mídia da Concorrência',
  salesAttributedToCompetitionSales: 'Vendas Atribuídas às Vendas da Concorrência',
  averageMediaMix: 'Mix de Mídia Médio',
  averageMediaMixTooltip: 'Distribuição média do gasto entre todos os diferentes canais de mídia. Embora este mix possa ser dinâmico ao longo do tempo, essas variações são definidas no Modelo de Referência, enquanto esta entrada serve para escalar corretamente o mix para a marca alvo.',
  channelAttributionError: 'A soma de todos os canais deve ser 100%, não {total}%',
  seasonality: 'Sazonalidade',
  periodicBoostingEffect: 'Efeito de Impulso Periódico/Cíclico em Vendas (%)',
  periodicBoostingInfo: 'Este número representa um efeito de "impulso" (multiplicador) nas vendas devido a um evento periódico/cíclico específico, ou seja, eventos sazonais que normalmente se repetem ano após ano. Por exemplo, um valor de 130% significa que as vendas durante esse período serão "impulsionadas" em 30% em comparação com um período normal.',
  spotEventsBoostingEffect: 'Efeito de Impulso de Eventos Pontuais em Vendas (%)',
  spotEventsBoostingInfo: 'Eventos pontuais são aqueles que ocorrem apenas durante o mês mas se espera que se repitam a cada ano, por exemplo Cyber Days, Black Friday, Dia das Mães, etc. Assim como os eventos Periódicos, esses valores são efeitos de "impulso" (multiplicador) nas vendas.',
  required: 'Obrigatório',
  mustBeGreaterThanZero: 'Deve ser maior que 0',
  selectEkrmCategory: 'Selecionar Categoria EKRM',
  selectStandardCategory: 'Selecionar Categoria de Modelo de Referência Padrão',
  categoryName: 'Nome da Categoria',
  dateCreated: 'Data de Criação',
  createdBy: 'Criado Por'
}
